import {base64DecodeUnicode} from "./utilities/base64";
import {initInputBody} from "./inputfile";
import {initInputMaskDate} from "./inputMaskDate";
import {initPhoneCountryFields} from "./phoneCountryField";
import {focusInputGroups} from "./checkInputGroups";

function loadRecaptchaHtml(formWrapper) {
    formWrapper.innerHTML = base64DecodeUnicode(formWrapper.dataset.html);

    const form = formWrapper.querySelector("form");
    if (!form) {
        return;
    }

    initInputMaskDate(formWrapper.querySelectorAll('input[type="date"],.js-inputMasketDate'));
    initInputBody(formWrapper.querySelectorAll('.fileBody'));
    initPhoneCountryFields(formWrapper.querySelectorAll("input[type=tel]"));
    focusInputGroups(formWrapper.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));

    if (formWrapper.querySelector(".contactform")) {
        formWrapper.querySelector(".contactform").style.opacity = 1;
    }

    form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (typeof grecaptcha === "undefined" || !grecaptcha.execute) {
            console.error("[reCAPTCHA] grecaptcha nicht geladen oder execute nicht verfügbar.");
            return;
        }

        grecaptcha.ready(() => {

            const siteKey = form.dataset.sitekey;
            if (!siteKey) {
                console.error("[reCAPTCHA] Site Key nicht gefunden.");
                return;
            }

            grecaptcha.execute(siteKey, {action: 'submit'})
                .then((token) => {
                    const event = new CustomEvent("recaptcha:success", {
                        detail: {token, form: form}
                    });
                    formWrapper.dispatchEvent(event);
                    form.submit();
                })
                .catch((err) => {
                    console.error("[reCAPTCHA] execute() fehlgeschlagen:", err);
                });
        });
    });
}

export function initRecaptchaForms(wrapper = document) {
    const observer = new MutationObserver(function (mutationList, observer) {
        for (let mutation of mutationList) {
            let target = mutation.target;
            if (target) {
                loadRecaptchaHtml(target);
            }
        }
    });

    for (let form of wrapper.querySelectorAll('.js-RecaptchaForm')) {
        observer.observe(form, {
            attributes: true,
            childList: false,
            subtree: false
        });
    }
}